import { normalizeAccountData } from "./Normalizers";
import useCallAxios from "./useCallAxios";
import { UserContext } from "../Contexts/User";
import { useIbProductFeaturesStore } from "../Stores/ibProductFeaturesStore";
import React from "react";

const filterQuery = (values) => ({ ...values });

export const useAccountData = () => {
  const [, dispatchUserContext] = React.useContext(UserContext);
  const context = `accountSettings`;
  const { reset, requestSuccess, requestData, requestLoading, fetchGET } =
    useCallAxios({
      context,
    });

  const state = normalizeAccountData(requestData);
  const { userName, userId } = state;

  const lastDispatchedRef = React.useRef({ userId: "", userName: "" });

  // Sync product gates after render — setState during normalizeAccountData
  // re-rendered PrivateRouter/MenuNavigation mid-Dashboard render and hung the home spinner.
  React.useEffect(() => {
    const raw = requestData?.data?.features;
    if (!raw || typeof raw !== "object") return;
    useIbProductFeaturesStore.getState().setFeatures(raw);
  }, [requestData]);

  React.useEffect(() => {
    if (!userName?.length || !userId?.length) return;

    if (
      lastDispatchedRef.current.userId === userId &&
      lastDispatchedRef.current.userName === userName
    ) {
      return;
    }

    lastDispatchedRef.current = { userId, userName };
    dispatchUserContext({
      type: "setSettingsUser",
      userId,
      userName,
    });
  }, [dispatchUserContext, userName, userId]);

  const fetchGETRef = React.useRef(fetchGET);
  fetchGETRef.current = fetchGET;

  const handleGET = React.useCallback((params) => {
    fetchGETRef.current({ context, queryParameters: filterQuery(params) });
  }, [context]);

  sessionStorage.setItem("@BCBankline:Qrcode", state.userURL);

  return {
    reset,
    loading: requestLoading,
    state,
    success: requestSuccess,
    handleGET,
  };
};
